import React from 'react';

import { Button, Col, Row } from 'react-bootstrap';
require('./styles.scss');

export class ServerError extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="page-header">
              <span> ESS Monitoring </span>
            </div>
          </Col>
        </Row>

        <Col md={12}>
          <div className="page-content-div">
            <h1> Server error </h1>
            <h4>
              Sorry there is some issue in server, please try again after some
              time.
            </h4>
            <Button
              bsStyle="link"
              className=" btn btn-primary btn-sm"
              onClick={() => (window.location.pathname = '/')}>
              Click here to try again
            </Button>
          </div>
        </Col>
      </div>
    );
  }
}

export default ServerError;
